import { render, staticRenderFns } from "./refund-detail.vue?vue&type=template&id=17348eec&scoped=true&"
import script from "./refund-detail.vue?vue&type=script&lang=js&"
export * from "./refund-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-detail.vue?vue&type=style&index=0&id=17348eec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17348eec",
  null
  
)

export default component.exports